import { useEffect, useState } from 'react'
import { isAnyBlank } from '../../utils/string'
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField
} from '@mui/material'
import { formatMinutesToSeconds } from '../../utils/time'
import AsignaturaSelector from '../../components/form/AsignaturaSelector/AsignaturaSelector'
import css from './ModalNuevoVideo.module.css'

const ModalNuevoVideo = ({ open, onSubmit, onClose, isLoading }) => {
  const [video, setVideo] = useState({
    nombre: '',
    url: 'https://www.youtube.com/watch?v=',
    duracion: '',
    asignaturas: []
  })

  useEffect(() => {
    if (open)
      setVideo({
        nombre: '',
        url: 'https://www.youtube.com/watch?v=',
        duracion: '',
        asignaturas: []
      })
  }, [open])

  const isSubmitDisabled = isAnyBlank(video.nombre, video.url, video.duracion)

  const handleSubmit = () => {
    onSubmit({
      nombre: video.nombre,
      url: video.url,
      duracion: formatMinutesToSeconds(video.duracion),
      asignaturas: video.asignaturas
    })
  }

  return (
    <Dialog onClose={onClose} open={open} fullWidth maxWidth='md'>
      <DialogTitle>Nuevo vídeo</DialogTitle>
      <DialogContent className={css.main}>
        <DialogContentText className={css.intro}>
          Utiliza este formulario para crear un nuevo vídeo
        </DialogContentText>
        <TextField
          className={css.input}
          label='Nombre'
          value={video.nombre}
          onChange={e => setVideo({ ...video, nombre: e.target.value })}
          variant='standard'
        />
        <TextField
          className={css.input}
          label='ID del vídeo'
          value={video.url}
          onChange={e => setVideo({ ...video, url: e.target.value })}
          variant='standard'
        />
        <TextField
          className={css.input}
          label='Duración'
          value={video.duracion}
          placeholder='mm:ss'
          onChange={e => setVideo({ ...video, duracion: e.target.value })}
          variant='standard'
        />
        <AsignaturaSelector
          className={css.input}
          label='Asignaturas'
          multiple={true}
          value={video.asignaturas}
          onChange={(event, newValue) =>
            setVideo({
              ...video,
              asignaturas: newValue?.map(asig => asig.id) || []
            })
          }
        />
      </DialogContent>
      <DialogActions>
        <Button color='error' onClick={onClose}>
          Cancelar
        </Button>
        <Button
          disabled={isSubmitDisabled || isLoading}
          color='primary'
          onClick={handleSubmit}
          startIcon={isLoading && <CircularProgress size={12} />}
        >
          Enviar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ModalNuevoVideo
